import { OpenAPI } from "api/generated/cms";
import { keycloakService } from "services/keycloakService";

const baseUrl = process.env.REACT_APP_CMS_API_BASE_URL;

if (!baseUrl) {
  throw new Error("REACT_APP_CMS_API_BASE_URL is not defined");
}

OpenAPI.BASE = baseUrl.replace(/\/$/, "");
OpenAPI.CREDENTIALS = "omit";
OpenAPI.HEADERS = async () => {
  const token = await keycloakService.getToken();
  return { "x-fa-token": token ?? "" };
};
